import React, { useState } from "react";
import axios from "axios";
import img from "../../assets/images/list_you_property_banner.jpg";
import BottomNav from "../../component/BottomNav";
import { API_URL } from "../../common/constant";

const Modal = ({ message, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
      <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full text-center transform transition-all duration-300 scale-100 hover:scale-105">
        <p className="text-2xl font-semibold text-gray-800 mb-6">{message}</p>
        <button
          onClick={onClose}
          className="mt-6 bg-[#54BD95] text-white py-3 px-10 rounded-full hover:bg-[#4BAF7D] transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none"
        >
          Close
        </button>
      </div>
    </div>
  );
};

const Agent_listing = () => {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    email: "",
    workingArea: "",
    experience: "",
    sellRent: "",
    commercialResidentials: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({}); // For storing error messages

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors("")
    setFormData({ ...formData, [name]: value });
  
    let validationErrors = { ...errors };
  
    if (name === "name") {
      if (!value) {
        validationErrors.name = "Name is required";
      } else if (value.length < 3) {
        validationErrors.name = "Name must be at least 3 characters long";
      } else {
        delete validationErrors.name;
      }
    }

    if (name === "workingArea") {
        if (!value) {
          validationErrors.workingArea = " Working area is required";
        } else if (value.length < 4) {
          validationErrors.workingArea = "Working Area must be at least 4 characters long";
        } else {
          delete validationErrors.workingArea;
        }
      }
  
    if (name === "number") {
        // Allow only numbers
        const newValue = value.replace(/\D/g, ""); // Remove non-numeric characters
    
        if (!newValue) {
          validationErrors.number = "Phone number is required";
        } else if (newValue.length !== 10) {
          validationErrors.number = "Phone number must be exactly 10 digits";
        } else {
          delete validationErrors.number;
        }
      }
  
    setErrors(validationErrors);
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");
    setErrors({});

    const { name, number, email, workingArea, experience, sellRent, commercialResidentials } = formData;
    
    // Validate all required fields
    let validationErrors = {};
    if (!name) validationErrors.name = "Name is required";
    if (!number) validationErrors.number = "Phone number is required";
    
    if (!workingArea) validationErrors.workingArea = "Working area is required";
    if (!experience) validationErrors.experience = "Experience is required";
    if (!sellRent) validationErrors.sellRent = "Sell/Rent selection is required";
    if (!commercialResidentials) validationErrors.commercialResidentials = "Property type is required";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }

    try {
      // API call to add broker
      const response = await axios.post(`${API_URL}/api/brokers/add`, formData);
      setSuccessMessage("Broker added successfully!");
      setShowModal(true);
      setFormData({
        name: "",
        number: "",
        email: "",
        workingArea: "",
        experience: "",
        sellRent: "",
        commercialResidentials: "",
      });
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Failed to add broker. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div >
      <div
        className="flex flex-col sm:flex-row items-center bg-cover bg-center px-4"
        style={{ backgroundImage: `url(${img})` }}
      >
        <div className="w-full sm:w-1/2 p-4 lg:p-12">
          <h1 className="lg:text-4xl text-3xl font-bold text-white mb-6">
            Join PlaceZio Estate – Where Ambitions Meet Success
          </h1>
          <p className="text-lg text-white">
            At Placezio Estate, we empower our agents with the tools and support to thrive.
            Join us today and start building your successful career in real estate.
          </p>
        </div>

        <div className="w-full sm:w-1/2 bg-white p-6 lg:p-8 mt-12 mb-12 mx-1 rounded-2xl shadow-xl">
        <h1 className="w-full text-center text-4xl text-[#54BD95] font-bold">Register Now</h1>

      <form onSubmit={handleSubmit} className="space-y-6 h-full mt-11 mb-4 ">
    <div className="grid grid-cols-1 sm:grid-cols-2  gap-6">
      <div>
        <label htmlFor="name" className="block text-gray-700 font-medium mb-1">
          Name*
        </label>
        <input
          id="name"
          type="text"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          placeholder="Enter your name"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg"
        />
        {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
      </div>

      <div>
        <label htmlFor="number" className="block text-gray-700 font-medium mb-1">
          Phone Number*
        </label>
        <input
          id="number"
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          onKeyDown={(e) => {
            if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
              e.preventDefault();
            }
          }}
          name="number"
          value={formData.number}
          onChange={handleInputChange}
          placeholder="Enter your phone number"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg"
        />
        {errors.number && <p className="text-red-500 text-sm mt-1">{errors.number}</p>}
      </div>

      <div>
        <label htmlFor="email" className="block text-gray-700 font-medium mb-1">
          Email
        </label>
        <input
          id="email"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          placeholder="Enter your email"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg"
        />
      </div>

      <div>
        <label htmlFor="workingArea" className="block text-gray-700 font-medium mb-1">
          Working Area*
        </label>
        <input
          id="workingArea"
          type="text"
          name="workingArea"
          value={formData.workingArea}
          onChange={handleInputChange}
          placeholder="Enter your working area like: Gomti Nagar, Hazratganj"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg"
        />
        {errors.workingArea && <p className="text-red-500 text-sm mt-1">{errors.workingArea}</p>}
      </div>

      <div>
        <label htmlFor="experience" className="block text-gray-700 font-medium mb-1">
          Experience (years)*
        </label>
        <input
          id="experience"
          type="text"
          name="experience"
          value={formData.experience}
          onChange={handleInputChange}
          placeholder="Enter your experience (years)"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg"
        />
        {errors.experience && <p className="text-red-500 text-sm mt-1">{errors.experience}</p>}
      </div>

      <div>
        <label htmlFor="sellRent" className="block text-gray-700 font-medium mb-1">
          Property Deal Type*
        </label>
        <select
          id="sellRent"
          name="sellRent"
          value={formData.sellRent}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg"
        >
          <option value="">Select Deal Type</option>
          <option value="Sell">Sell</option>
          <option value="Rent">Rent</option>
          <option value="Both">Both</option>
        </select>
        {errors.sellRent && <p className="text-red-500 text-sm mt-1">{errors.sellRent}</p>}
      </div>

      <div>
        <label htmlFor="commercialResidentials" className="block text-gray-700 font-medium mb-1">
          Property Type*
        </label>
        <select
          id="commercialResidentials"
          name="commercialResidentials"
          value={formData.commercialResidentials}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg"
        >
          <option value="">Select Property Type</option>
          <option value="Commercial">Commercial</option>
          <option value="Residential">Residential</option>
          <option value="Both">Both</option>
        </select>
        {errors.commercialResidentials && <p className="text-red-500 text-sm mt-1">{errors.commercialResidentials}</p>}
      </div>
    </div>

    {/* Submit Button - Positioned Below */}
    <div className="mt-24">
    <button
      type="submit"
      className="w-full mt-12 bg-[#54BD95] text-white font-medium py-2 px-4 rounded-lg hover:bg-[#4BAF7D] transition duration-200"
      disabled={loading}
    >
      {loading ? "Submitting..." : "Submit"}
    </button>
    </div>
  </form>

</div>

      </div>

      {showModal && (
        <Modal message="Submit successfully!" onClose={() => setShowModal(false)} />
      )}
      <BottomNav />
    </div>
  );
};

export default Agent_listing;
